import { getElblackBaseUrl } from './api-config';

export const IS_NP = false
export const IS_GETENC = true

export const DEBUG_LOCAL_RESPONSE = false;
export const DEBUG_DOWNLOAD_RESPONSE = false;
export const DEBUG_FILTER = false;

// Global services configuration for performance optimization
export const SERVICES_CONFIG = {
    NAVAREA: false,
    AIO: false,
    AIS: false,
    WEATHER: false,
    PORTS: true, // Включаем порты по умолчанию
};

// AIS data source configuration
export const AIS_CONFIG = {
    // Использовать ли удалённый сервис AIS для обогащения данных флота и карты
    USE_REMOTE_AIS_SERVICE: SERVICES_CONFIG.AIS,
    // Базовый адрес сервиса AIS, из которого получаем информацию и изображения
    REMOTE_BASE_URL: getElblackBaseUrl(),
    // Путь ручки для получения данных по конкретному IMO (добавляется к REMOTE_BASE_URL)
    REMOTE_POSITION_PATH: '/api/ais/position',
    // Опциональный публичный адрес фронтенда для построения ссылок на изображения
    FRONT_STATIC_BASE_URL: (typeof window !== 'undefined' && window.location.hostname.endsWith('ecdis-link.net')) ? 'ecdis-link.net' : 'ecdis-link.com',
};

// Navarea display configuration
export const NAVAREA_CONFIG = {
    // Режим отображения navarea объектов:
    // true - линейные объекты отображаются как отдельные точки (безопасный режим)
    // false - линейные объекты отображаются как полигоны/линии (по умолчанию)
    DISPLAY_POLYGONS_AS_POINTS: true,
    
    // Максимальное количество точек в полигоне, выше которого он будет разбит на отдельные точки
    MAX_POLYGON_POINTS: 20
};


export const CURRENT_PRODUCT = {
    is_navicom: false
};
